import { render, staticRenderFns } from "./ForgotEmail.vue?vue&type=template&id=0dfaf598&scoped=true"
var script = {}
import style0 from "./ForgotEmail.vue?vue&type=style&index=0&id=0dfaf598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfaf598",
  null
  
)

export default component.exports